import { WO_PAGES } from "@common/flags"
import type { QueryClient } from "@tanstack/react-query"
import { requireFeatureFlag } from "@/lib/require-feature-flag"
import { requirePermission } from "@/lib/require-permission"

export async function requireForecastPages(
  queryClient: QueryClient,
): Promise<void> {
  await requirePermission(queryClient, "forecast:read", "/")
  await requireFeatureFlag(queryClient, WO_PAGES)
}
